import {Permission} from './auth/SessionPlusAuthenticator'

export interface ApiDocumentation {
  name: string
  description: string
  path: string
  openApiPath: string
  permissions: Permission[]
}

export const apis: ApiDocumentation[] = [
  {
    name: 'AEM',
    description: '',
    path: '/docs/search-aem',
    openApiPath: '/oegbv-aem.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'ARfBR',
    description: '',
    path: '/docs/arfbr',
    openApiPath: '/oegbv-arfbr.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'Authentifizierung',
    description: '',
    path: '/docs/auth',
    openApiPath: '/oegbv-auth.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'Betriebsräte (Entwurf)',
    description: '',
    path: '/docs/betriebsraete',
    openApiPath: '/oegbv-betriebsraete.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'Book (Legacy)',
    description: '',
    path: '/docs/book',
    openApiPath: '/oegbv-book.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'Books v2 (Entwurf)',
    description: '',
    path: '/docs/books',
    openApiPath: '/oegbv-books.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'DIS',
    description: '',
    path: '/docs/dis',
    openApiPath: '/oegbv-dis.yaml',
    permissions: [Permission.API_ADMIN, Permission.API_DIS],
  },
  {
    name: 'Ebooks',
    description: '',
    path: '/docs/ebooks',
    openApiPath: '/oegbv-ebooks.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'GEMS',
    description: '',
    path: '/docs/gems',
    openApiPath: '/oegbv-gems.yaml',
    permissions: [Permission.API_ADMIN, Permission.API_GEMS],
  },
  {
    name: 'Indexing',
    description: '',
    path: '/docs/indexing',
    openApiPath: '/oegbv-indexing.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'KV',
    description: '',
    path: '/docs/kv',
    openApiPath: '/oegbv-kv.yaml',
    permissions: [Permission.API_ADMIN, Permission.API_KVSYSTEM],
  },
  {
    name: 'KV-Lohndaten',
    description: '',
    path: '/docs/kv-lohndaten',
    openApiPath: '/oegbv-kv-lohndaten.yaml',
    permissions: [Permission.API_ADMIN, Permission.API_LOHNDATEN],
  },
  {
    name: 'Law',
    description: '',
    path: '/docs/law',
    openApiPath: '/oegbv-law.yaml',
    permissions: [Permission.API_ADMIN],
  },

  {
    name: 'Processing Queue',
    description: '',
    path: '/docs/processing-queue',
    openApiPath: '/oegbv-processing-queue.yaml',
    permissions: [Permission.API_ADMIN],
  },
  {
    name: 'Registrierung',
    description: '',
    path: '/docs/registration',
    openApiPath: '/oegbv-registration.yaml',
    permissions: [Permission.API_ADMIN],
  },
]
